import { Vector3 } from 'three';
import { getDefaultObjectId, ObjectType } from '../../utils/attributes/defaultObjectsAndAttributes';
import { DEFAULT_RADIATOR_DEPTH, DEFAULT_RADIATOR_LENGTH, DEFAULT_RADIATOR_NICHE_DEPTH } from '../../utils/constants';
import Entity, { IEntity } from '../abstract/Entity';
import { IAttribute } from './AttributeModel';

export interface IRadiator extends IEntity {
  position: Vector3;
  length: number;
  depth: number;
  angle: number;
  nicheDepth: number;
}

class RadiatorModel extends Entity implements IRadiator {
  position: Vector3;
  length: number;
  depth: number;
  angle: number;
  nicheDepth: number;

  readonly filesApiId: number | undefined = getDefaultObjectId(ObjectType.Radiator);

  constructor(
    position: Vector3,
    length = DEFAULT_RADIATOR_LENGTH,
    depth = DEFAULT_RADIATOR_DEPTH,
    angle = 0,
    attributes: Array<IAttribute> = [],
    uuid: string | undefined = undefined,
    nicheDepth = DEFAULT_RADIATOR_NICHE_DEPTH,
  ) {
    super(attributes);
    if (uuid) {
      this.uuid = uuid;
    }
    this.position = position;
    this.length = length;
    this.depth = depth;
    this.angle = angle;
    this.attributes = attributes;
    this.nicheDepth = nicheDepth;
  }

  getPosition(): Vector3 {
    return this.position;
  }

  setPosition(value: Vector3): void {
    this.position = value;
  }

  getLength(): number {
    return this.length;
  }

  setLength(value: number): void {
    this.length = value;
  }

  getDepth(): number {
    return this.depth;
  }

  setDepth(value: number): void {
    this.depth = value;
  }

  getAngle(): number {
    return this.angle;
  }

  setAngle(value: number): void {
    this.angle = value;
  }

  getNicheDepth(): number {
    return this.nicheDepth;
  }

  setNicheDepth(value: number): void {
    this.nicheDepth = value;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      position: { x: this.position.x, y: this.position.y, z: this.position.z },
      length: this.length,
      depth: this.depth,
      angle: this.angle,
      nicheDepth: this.nicheDepth,
    };
  }
}

export default RadiatorModel;
